import * as React from 'react'
import Modal from 'LuxKit/Modal/Modal'

export interface SearchFloatingPanelProps {
  title: string
  isOpen?: boolean
  children: React.ReactNode
  confirmText?: string
  onConfirm?: () => void
  onClose: () => void
  onGoBack: () => void
  isConfirmButtonHidden?: boolean
  confirmButtonDisabled?: boolean
  secondaryActionText?: string
  onSecondaryActionClick?: () => void
}

const SearchFloatingPanel = React.forwardRef<HTMLDivElement, SearchFloatingPanelProps>((props, ref) => {
  const {
    title,
    isOpen,
    confirmText,
    onConfirm,
    onClose,
    onGoBack,
    children,
    isConfirmButtonHidden,
    confirmButtonDisabled,
    secondaryActionText,
    onSecondaryActionClick,
  } = props

  return (
    <Modal
      ref={ref}
      mode="drawer"
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      onBack={onGoBack}
      primaryActionText={confirmText}
      onPrimaryActionClick={onConfirm}
      isPrimaryActionDisabled={confirmButtonDisabled}
      isPrimaryActionHidden={isConfirmButtonHidden}
      secondaryActionText={secondaryActionText}
      onSecondaryActionClick={onSecondaryActionClick}
      flushListItems
    >
      {children}
    </Modal>
  )
})

SearchFloatingPanel.displayName = 'SearchFloatingPanel'

export default SearchFloatingPanel
